// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiEndpoint: 'https://academyapi.balady.gov.sa/api',
//  apiEndpoint: 'http://10.80.27.26/api',
  baseUrl: 'https://academyapi.balady.gov.sa/fetch-image?load=',
//  baseUrl: 'http://10.80.27.26/fetch-image?load=',
  openIdRedirect: '',
  notFoundImage: 'assets/image/notfound.png',
  passPhrase: 'e1d822ae154bfb1c02e2f2f0f2bd26be3b91cde7',
  staticToken:
    // eslint-disable-next-line max-len
'esraa'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

